import userUtils from '@/pages/User/user.utils'
import { IUser } from '@/pages/Users/users.types'
import Button from '@/shared/Buttons/Button'
import cn from '@/utils/cn'
import css from './avatarUpload.module.css'
import Skeleton from '@/shared/Loaders/Skeleton'
import useAvatarCtrl from '@/shared/Avatar/useAvatarCtrl'

interface IProps {
  user: IUser
  fileInputHandler: () => void
  loading: boolean
}

const AvatarUpload = (props: IProps) => {
  const avatarFileName = props.user.userInfo?.avatar?.fileName
  const ctrl = useAvatarCtrl(avatarFileName ? props.user.id : null, avatarFileName)

  const renderAvatar = () => {
    if (props.loading) {
      return <Skeleton height="72px" width="72px" />
    }

    if (props.user.userInfo.avatar) return <img src={ctrl.url} alt="Аватар" className={css.avatarImage} />

    return (
      <span className="text-heading-5" style={{ color: 'var(--text-description)' }}>
        {userUtils.getUserAlias(props.user.userInfo)}
      </span>
    )
  }

  return (
    <div className="inline-flex-gap gap16 center">
      <div className={cn('flex-lines center', css.avatarContainer)}>{renderAvatar()}</div>
      <div className="flex-lines gap8">
        <Button size="default" type="default" text="Загрузить фотографию" onClick={props.fileInputHandler} />
        <p className="text-sm">JPG, PNG. Максимальный размер — 2 МБ</p>
      </div>
    </div>
  )
}

export default AvatarUpload
